<template>
    <div class="TimeSlotSelector">
        <v-container fluid>
            <p>Selecteer een beschikbare datum en kies vervolgens het gewenste tijdstip:</p>
            <p>Afspraak*</p>
            <v-card
                class="d-flex align-start flex-row v-card-timeslot"
                flat
                >
                <v-card outlined class="v-card-datepicker">
                    <v-date-picker no-title locale="nl"
                                :allowed-dates="setAllowedDate"
                                :first-day-of-week="1"
                                :show-current="false"
                                v-model="selectedDate"
                                class="mt-4"
                                @change="selectDate"
                                >
                    </v-date-picker>
                </v-card>
                <v-card flat class="timeslots">
                    <v-btn class="ma-2"
                           outlined
                           :style="`border-color: ${timeSlotBorderColor}`"
                           v-for="timeSlot in timeSlots" :key="timeSlot.timeText"
                           @click="selectTimeSlot(timeSlot)">
                           {{timeSlot.timeText}}
                    </v-btn>
                </v-card>
            </v-card>
        </v-container>
    </div>
</template>

<style scoped>
    .v-card-datepicker {
        margin: 0 15px 0 0;
    }
    @media only screen and (max-width: 550px) {
        .v-card-timeslot {
            display: inline-block !important;
            text-align: center;
        }
        .v-card-datepicker {
            margin: 0 0 15px 0;
        }
    }
</style>

<script>
/* eslint-disable */
import {services} from "../_services";
import * as moment from "moment";
import { mapState, mapActions } from "vuex";

export default {
    props: {
        formModel: Object,
        resetData: Boolean,
        selected: Boolean,
    },
    computed: {
        ...mapState("app", ["status", "siteInfo"]),

        appointmentTypeChange() {
            return this.formModel.appointmentType;
        },
        locationIdChange() {
            return this.formModel.locatieId;
        },
        therapeutIdChange() {
            return this.formModel.therapeutId;
        }       
    },
    methods: {
        ...mapActions({
          clearAlert: "alert/clear",
          showAlert: "alert/error",
          selectComp: "appBar/selectComp",
          updateFormModel: "appBar/updateFormModel",
        }),
        setAllowedDate(val) { 
            return this.allowedDates.some(x => x == val);
        },
        setAllowedDates() {
            if(!this.keuzeDatums)
                return;
            
            this.allowedDates = this.keuzeDatums.map(x => x.dateText);
        },
        mapDateTimeSlots(data) {
            this.keuzeDatums = data.map(dayItem => {
                var day = {};
                var timeSlots = [];
                var timeSlot = {};
                
                dayItem.timeslots.forEach(timeItem => {
                    //add new property to be used in displaying timeslot
                    timeSlot = {
                        timeText: moment(timeItem.tijdvanaf).format('HH:mm') + " tot " + moment(timeItem.tijdtot).format('HH:mm'),
                    };

                    timeSlot = {...timeItem, ...timeSlot};
                    timeSlots = timeSlots.concat(timeSlot);
                });

                day = {
                    dateText: moment(dayItem.keuzeDatum).format('YYYY-MM-DD'),
                    timeslots: timeSlots,
                };

                return {...dayItem, ...day};
            });
        },
        selectDate() {
            this.timeSlots = this.keuzeDatums.find(x => x.dateText == this.selectedDate).timeslots;
        },
        selectTimeSlot(timeSlot) {   
            moment.locale('nl');
            var dateTitle = moment(timeSlot.tijdvanaf).format('dddd DD MMMM ') + moment(timeSlot.tijdvanaf).format('HH:mm') + " tot " + moment(timeSlot.tijdtot).format('HH:mm');
            var appointmentId = moment(timeSlot.tijdvanaf).format("YYYY-MM-DD HH:mm") + "|" + moment(timeSlot.tijdtot).format("YYYY-MM-DD HH:mm") + "|" + timeSlot.locatieId + "|" + timeSlot.ruimteId;
            var $this = this;
            
            this.updateFormModel({
                formModel: {
                    id: 4,
                    title: dateTitle,
                    appointmentId: appointmentId,
                    appointmentMoment: dateTitle,
                    selected: true
                }, callback: function () {
                $this.selectComp({ id: 5, type: "select", resetData: true, emptySelection: false });
            }});
        },
        clearSelection() {
            if(this.resetData == true) {
                this.updateFormModel({ formModel: { id: 4, title: "", appointmentId: null, appointmentMoment: null, selected: false }});
            }
        },
        fetchTimeSlots() {
            services.fetchTimeSlots(this.formModel).then(
                (data) => {
                    this.timeSlots = [];
                    this.mapDateTimeSlots(data.keuzeDatums);
                    this.setAllowedDates();
                },
                (error) => {
                    this.showAlert(error);
                }
            );
        }
    },
    mounted: function() {
        this.setAllowedDates();
        this.timeSlotBorderColor = this.siteInfo.colorInfo.timeSlotBorderColor;
    },
    data: () => ({
        keuzeDatums: null,
        timeSlots: [],
        selectedDate: null,
        allowedDates: [],
    }),
    watch:
    {
        appointmentTypeChange() {
            if (this.formModel.appointmentType != null && this.formModel.appointmentType != 0 && this.formModel.therapeutId != null && this.formModel.therapeutId != 0) {
                this.fetchTimeSlots();
            }
        },
        therapeutIdChange() {
            if (this.formModel.therapeutId != null && this.formModel.therapeutId != 0) {
                this.fetchTimeSlots();
            }
        },
        locationIdChange() {
            if (this.formModel.locatieId != null && this.formModel.locatieId != 0) {
                this.fetchTimeSlots();
            }
        },
        resetData() {
            this.clearSelection();
        }
    }
}
</script>